import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=b34d0bba&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventCard.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventCard.vue?vue&type=style&index=0&id=b34d0bba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34d0bba",
  null
  
)

export default component.exports